module.exports = __webpack_public_path__ + "static/img/bystage_white_08.882d39de.svg";